import{gql as e}from"@apollo/client";import{GELADA_PROJECT_FRAGMENT as o}from"../../graphql/fragments/geladaProject.fragment.js";const t=e`
  mutation createGeladaProject(
    $isCustomBuild: Boolean!
    $name: String!
    $organisationId: Int!
    $description: String
    $key: String!
    $logo: CreateAssetBaseInputType
    $shouldIncludeProjectDomain: Boolean = false
    $shouldIncludeProjectLogo: Boolean = false
    $shouldIncludeProjectSettings: Boolean = false
    $shouldIncludeProjectTheme: Boolean = false
  ) {
    project {
      createGeladaProject: createProject(
        project: {
          isCustomBuild: $isCustomBuild
          name: $name
          organisationId: $organisationId
          key: $key
          logo: $logo
          description: $description
        }
      ) {
        ...geladaProjectFragment
      }
    }
  }

  ${o}
`;export{t as CREATE_GELADA_PROJECT_MUTATION};
//# sourceMappingURL=useCreateGeladaProject.graphql.js.map
